import { appendAwsAttachment } from './dom/attachmentRenderer';
import { appendEvent } from './dom/eventRenderer';
import { appendMessage } from './dom/messageRenderer';
import { clearTypingIndicator, showTypingIndicator } from './dom/typingIndicator';
import { attachmentUrl } from './apiRoutes';

const CONTENT_TYPE = {
  EVENT: 'EVENT',
  MESSAGE: 'MESSAGE',
  ATTACHMENT: 'ATTACHMENT'
};

const EVENT_CONTENT_TYPE = {
  PARTICIPANT_JOINED: 'application/vnd.amazonaws.connect.event.participant.joined',
  PARTICIPANT_LEFT: 'application/vnd.amazonaws.connect.event.participant.left',
  CHAT_ENDED: 'application/vnd.amazonaws.connect.event.chat.ended',
  TYPING: 'application/vnd.amazonaws.connect.event.typing'
};

const PARTICIPANT_ROLE = {
  CUSTOMER: 'CUSTOMER',
  AGENT: 'AGENT',
  SYSTEM: 'SYSTEM'
};

const _processAwsAttachment = (container, content) => {
  if (content.ParticipantRole === PARTICIPANT_ROLE.CUSTOMER) {
    // Customer attachments are added to DOM once they are initiated
  } else if (content.ParticipantRole === PARTICIPANT_ROLE.AGENT && content.Attachments) {
    const awsConnectContactId = container.dataset.awsConnectContactId;
    const messageGroup = appendMessage(container, 'agent', null, content.DisplayName);
    if (messageGroup) {
      content.Attachments.forEach((attachment) => {
        if (attachment.Status !== 'APPROVED') return;

        const url = attachmentUrl(awsConnectContactId, attachment.AttachmentId);
        appendAwsAttachment(messageGroup, attachment, url);
      });
    }
  }
};

const _processAwsEvent = (container, content) => {
  if (content.ContentType === EVENT_CONTENT_TYPE.PARTICIPANT_JOINED) {
    if (content.ParticipantRole === PARTICIPANT_ROLE.CUSTOMER) {
      appendEvent(container, 'You have joined the chat');
    } else if (content.ParticipantRole === PARTICIPANT_ROLE.AGENT) {
      appendEvent(container, `${content.DisplayName} has joined the chat`);
    }
  } else if (content.ContentType === EVENT_CONTENT_TYPE.PARTICIPANT_LEFT) {
    appendEvent(container, `${content.DisplayName} has left the chat`);
  } else if (content.ContentType === EVENT_CONTENT_TYPE.CHAT_ENDED) {
    clearTypingIndicator(container);
    appendEvent(container, 'The chat has ended');
  } else if (content.ContentType === EVENT_CONTENT_TYPE.TYPING && content.ParticipantRole === PARTICIPANT_ROLE.AGENT) {
    showTypingIndicator(container, content.DisplayName);
  }
};

const _processAwsMessage = (container, content) => {
  clearTypingIndicator(container);

  if (content.ParticipantRole === PARTICIPANT_ROLE.SYSTEM) {
    appendEvent(container, content.Content);
  } else if (content.ParticipantRole === PARTICIPANT_ROLE.CUSTOMER) {
    // Customer messages are added to DOM once they are initiated
  } else if (content.ParticipantRole === PARTICIPANT_ROLE.AGENT) {
    appendMessage(container, 'agent', content.Content, content.DisplayName);
  }
};

export const processWebsocketContent = (container, content) => {
  if (content.Type === CONTENT_TYPE.EVENT) {
    _processAwsEvent(container, content);
  } else if (content.Type === CONTENT_TYPE.MESSAGE) {
    _processAwsMessage(container, content);
  } else if (content.Type === CONTENT_TYPE.ATTACHMENT) {
    _processAwsAttachment(container, content);
  }
};
